import axios from 'axios'
import cookie from 'js-cookie'
import { FormData } from '../types'
import { config, PAT_KEY } from '~/shared'

interface ContactProperties {
  typeform_botbuildingaudience?: string
  typeform_projecttype?: string
  typeform_companysize?: string
  typeform_awarenesssource?: string
}

interface EnrichContactParams {
  formData: Partial<FormData>
  workspaceId: string
}

/**
 * Maps form data to contact properties
 */
function mapFormDataToContactProperties(formData: Partial<FormData>): ContactProperties {
  const properties: ContactProperties = {}

  if (formData.role) {
    properties.typeform_botbuildingaudience = formData.role
  }

  if (formData.useCase) {
    properties.typeform_projecttype = formData.useCase
  }

  if (formData.companySize) {
    properties.typeform_companysize = formData.companySize
  }

  if (formData.discoverySource) {
    properties.typeform_awarenesssource = formData.discoverySource
  }

  return properties
}

/**
 * Enriches a contact with onboarding form data
 */
export async function enrichContact({ formData, workspaceId }: EnrichContactParams): Promise<void> {
  const properties = mapFormDataToContactProperties(formData)

  // Only make the API call if there are properties to update
  if (Object.keys(properties).length === 0) {
    return
  }

  try {
    const cloudPat = config.usePat ? config.pat ?? cookie.get(PAT_KEY) : undefined

    await axios.post(
      `${config.studioLambdaApiUrl}/enrich-contact`,
      { properties },
      {
        headers: {
          'x-botpress-workspace-id': workspaceId,
          authorization: config.usePat ? `Bearer ${cloudPat}` : undefined,
        },
        withCredentials: !config.usePat,
      }
    )
  } catch (error) {
    console.error('[Contact Enrichment] Failed to enrich contact:', error)
  }
}
